interface CtaBannerSectionProps {
    onOpenDemo: () => void;
}

const CtaBannerSection = ({ onOpenDemo }: CtaBannerSectionProps) => {
    return (
        <section className="gradient-bg text-white py-20">
            <div className="container mx-auto px-4 text-center max-w-3xl">
                <h2 className="text-3xl md:text-4xl font-extrabold mb-4">
                    Ready to Stop Losing Money on Wrong Deliveries?
                </h2>
                <p className="text-blue-200 text-lg mb-10">
                    Join car parts businesses already using StockEasy. Book your free demo today — no commitment required.
                </p>
                <button
                    onClick={onOpenDemo}
                    className="cta-amber text-white px-12 py-5 rounded-xl font-bold text-xl shadow-2xl hover:shadow-3xl transition transform hover:-translate-y-1"
                >
                    <i className="fas fa-calendar-check mr-2"></i> Book Your Free Demo
                </button>
            </div>
        </section>
    );
};

export default CtaBannerSection;
